import { Dispatch, SetStateAction, memo } from 'react';
import { IOrder, IOrderPaymentLines } from '../../../interfaces/Order';
import { ActionIcon, Grid, Menu, rem } from '@mantine/core';
import moment from 'moment';
import { type MRT_PaginationState } from 'mantine-react-table';
import { useTranslation } from 'react-i18next';
import { formatMoneyString, getCustomerFullName } from '../../../utils/strings';
import { IOrderProduct } from '../../../interfaces/Product';
import Table from '../../../components/Table';
import { getPiecesBreakdown, formatPiecesBreakdown } from '../../../utils/helpers/getAllPieces';
import { buildOrderFolio } from '../../../utils/ordersUtils';
import { IStore } from '../../../interfaces/Store';

export default memo(function TableView({
  orders = [],
  totalRowsCount = 0,
  pages = 0,
  isError = false,
  isLoading = false,
  pagination,
  setPagination
}: {
  orders: any;
  totalRowsCount: any;
  pages: any;
  isError: boolean;
  isLoading: boolean;
  pagination: MRT_PaginationState;
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
}) {
  const { t } = useTranslation(['FieldName']);
  const columns = [
    {
      accessorFn: (row) => buildOrderFolio((row as unknown as IOrder)?.folioPrefix, (row as unknown as IOrder)?.sequence),
      header: t('FieldName:order')
    },
    {
      accessorFn: (row) => moment(row.cleanedDateTime).format('DD/MM/YYYY hh:mm'),
      header: t('FieldName:cleanedDate')
    },
    {
      accessorFn: (row) => getCustomerFullName(row.customer.name, row.customer.lastName),
      header: t('FieldName:customer')
    },
    {
      accessorFn: (row) => {
        const orderProducts = row?.products || [];
        const orderBuyAndGerProducts = row?.buyAndGetProducts || [];
        return formatPiecesBreakdown(getPiecesBreakdown(orderProducts, orderBuyAndGerProducts), {
          measurementUnits: ((row as IOrder).createdIn as IStore)?.measurementUnits
        });
      },
      header: t('FieldName:pieces')
    },
    {
      accessorFn: (row) => formatMoneyString((row.total || 0).toFixed(2)),
      header: t('FieldName:total')
    },
    {
      accessorFn: (row) =>
        formatMoneyString(
          (
            row.total -
              row.paymentLines?.reduce(
                (prev: number, next: IOrderPaymentLines) => prev + (next?.amountPaid || 0),
                0
              ) || 0
          ).toFixed(2)
        ),
      header: t('FieldName:amountDue')
    },
    {
      accessorFn: (row) => row.notes,
      header: t('FieldName:notes')
    }
  ];

  return (
    <>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Table
            tableColumns={columns}
            pagination={pagination}
            setPagination={setPagination}
            tableData={orders}
            isError={isError}
            paginationIsLoading={isLoading}
            numPages={pages}
            totalRowsCount={totalRowsCount}
          />
        </Grid.Col>
      </Grid>
    </>
  );
});
